module.exports = __webpack_public_path__ + "static/media/navigation-firstScreen.d6c323e1.png";